export default __webpack_public_path__ + "static/media/access_placeholder.14639419.svg";